import styled from 'styled-components';

export const Container = styled.section`
    width: 100%;
    min-height: 120px;
    background-color: #FFF;
    border-radius: 8px;
    box-shadow: 3px 3px 5px rgba(0,0,0,.1);
    padding: 10px;
    padding-bottom: 15px;
    cursor: pointer;

    &:hover {
        background-color: #fef9f9;
    }
`;

export const DataTemplate = styled.div`
    display: grid;
    width: 100%;
    height: 100%;
    grid-template-rows:50px auto;
`;

export const RoomName = styled.div`
    font-size: 20px;
    color: ${props => props.theme.colors.primaryText};
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;


    @supports (-webkit-line-clamp: 2) {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: initial;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
`;

export const RoomStats = styled.div`
    display: flex;
    flex: 1;
    align-items: flex-end;
`;

export const RoomStat = styled.div`
    width: auto;
    height: 27px;
    position: relative;
    color: ${props => props.theme.colors.primaryText};
    background-color: #EFEFEF;
    padding-left: 20px;
    border-radius: 15px;
    margin-right: 10px;
    align-items: center;
    display: flex;
    padding-right: 10px;
    padding-left: 40px;
`;

export const RoomStatIcon = styled.div`
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-color: ${props => props.theme.colors.primaryLighten};
    position: absolute;
    top: 50%;
    left: 0px;
    transform: translateY(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
`;